// extracted by mini-css-extract-plugin
module.exports = {"section":"article-apps_section__gbDQE","apps":"article-apps_apps__pf8Wh","app":"article-apps_app__NuNAR"};